let vendorItems = [];
let vendorElements = [];
let currentPage = 1;
let itemsPerPage = 8;
let searchTimeout = null;
let categorySelect = null;
let subcategoriesLoaded = false;

function escapeHtml(text) {
    if (!text) return '';
    const div = document.createElement('div');
    div.textContent = text;
    return div.innerHTML;
}

function loadVendors() {
    const search = $('#vendorSearch').val() || '';
    const productCategoryId = $('#categoryFilter').val() || '';
    const params = new URLSearchParams();
    if (search) params.set('search', search);
    if (productCategoryId) params.set('product_category_id', productCategoryId);

    fetch('/api/vendors/marketplace?' + params.toString())
        .then(function (res) { return res.json(); })
        .then(function (data) {
            $('#vendorsLoadingState').addClass('d-none');
            $('#vendorsGrid').show();

            if (data.success && data.vendors) {
                vendorItems = data.vendors.map(function (v) {
                    const location = [v.region, v.district, v.country].filter(Boolean).join(', ') || '—';
                    const desc = v.business_name || '';
                    return {
                        uid: v.uid,
                        name: v.name || v.business_name || 'Vendor',
                        location: location,
                        description: desc,
                        category: v.primary_product_category || '',
                        categoryId: v.primary_product_category_id || '',
                        image: v.primary_image || '/assets/img/company/avatar.png',
                        productCount: v.product_count || 0
                    };
                });

                if (!subcategoriesLoaded && data.product_categories && data.product_categories.length) {
                    subcategoriesLoaded = true;
                    const $select = $('#categoryFilter');
                    $select.empty().append('<option value="">All Categories</option>');
                    data.product_categories.forEach(function (pc) {
                        $select.append($('<option></option>').val(pc.id).text(pc.name));
                    });
                    if (categorySelect && typeof categorySelect.destroy === 'function') {
                        categorySelect.destroy();
                        categorySelect = null;
                    }
                    if (typeof SlimSelect !== 'undefined') {
                        categorySelect = new SlimSelect({
                            select: '#categoryFilter',
                            placeholder: 'All Categories'
                        });
                    }
                }
            } else {
                vendorItems = [];
            }

            renderVendorCards();
            currentPage = 1;
            renderVendors();
            renderPagination();
            updateResultsCount();
        })
        .catch(function () {
            $('#vendorsLoadingState').addClass('d-none');
            $('#vendorsGrid').show();
            vendorItems = [];
            renderVendorCards();
            if (typeof notify !== 'undefined') notify('error', 'Failed to load vendors');
        });
}

function renderVendorCards() {
    const $grid = $('#vendorsGrid');
    $grid.empty();

    vendorItems.forEach(function (v) {
        const card = `
            <div class="col-6 col-md-4 col-lg-3 vendor-item">
                <div class="card vendor-card h-100 shadow-sm">
                    <div class="vendor-header">
                        <img src="/assets/img/company/logo-pack/awega_sacoma_logo.png" class="vendor-tile-logo" alt="Sacoma Health Foods Logo" width="130" loading="lazy">
                        <div class="vendor-avatar-wrap">
                            <span class="vendor-avatar-spinner"><span class="spinner-border spinner-border-sm text-primary" role="status"></span></span>
                            <img src="${escapeHtml(v.image)}" class="vendor-avatar" alt="" loading="lazy"
                                onerror="this.src='/assets/img/company/avatar.png'; this.onerror=null;">
                        </div>
                    </div>
                    <div class="card-body vendor-body text-center">
                        <h6 class="fw-semibold vendor-name">${escapeHtml(v.name)}</h6>
                        <div class="rating mb-1">
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                            <i class="fa-solid fa-star filled"></i>
                        </div>
                        <div class="vendor-location mb-1 vendor-location-text">
                            <i class="fa-solid fa-location-dot text-primary"></i>
                            ${escapeHtml(v.location)}
                        </div>
                        ${v.description ? `<div class="vendor-desc mb-2 vendor-description">${escapeHtml(v.description)}</div>` : ''}
                        ${v.productCount ? `<span class="badge bg-light text-dark border mb-2">${v.productCount} product${v.productCount !== 1 ? 's' : ''}</span>` : ''}
                        <a href="/marketplace/vendor/${encodeURIComponent(v.uid)}" class="btn btn-outline-primary rounded-pill w-100">
                            View Vendor
                        </a>
                    </div>
                </div>
            </div>
        `;
        $grid.append(card);
    });

    $grid.find('.vendor-avatar-wrap').each(function () {
        var $wrap = $(this);
        var $img = $wrap.find('.vendor-avatar');
        function markLoaded() {
            $wrap.addClass('loaded');
        }
        $img.on('load', markLoaded).on('error', markLoaded);
        if ($img[0].complete && $img[0].naturalWidth > 0) {
            markLoaded();
        }
    });

    vendorElements = $('.vendor-item').toArray().map(function (el) {
        return $(el);
    });
}

$(document).ready(function () {
    if (typeof SlimSelect !== 'undefined') {
        categorySelect = new SlimSelect({
            select: '#categoryFilter',
            placeholder: 'All Categories'
        });
    }

    loadVendors();

    $('#vendorSearch').on('input', function () {
        clearTimeout(searchTimeout);
        searchTimeout = setTimeout(function () {
            loadVendors();
        }, 400);
    });

    $('#categoryFilter').on('change', function () {
        loadVendors();
    });

    $('#clearFiltersBtn').on('click', function () {
        $('#vendorSearch').val('');
        if (categorySelect) {
            categorySelect.setSelected('');
        } else {
            $('#categoryFilter').val('');
        }
        loadVendors();
    });

    $(document).on('click', '#vendorsPagination .page-link', function (e) {
        e.preventDefault();
        const page = $(this).data('page');
        if (page && page !== currentPage) {
            currentPage = page;
            renderVendors();
            renderPagination();
            $('html, body').animate({
                scrollTop: $('#vendorsGrid').offset().top - 100
            }, 300);
        }
    });
});

function renderVendors() {
    $('.vendor-item').hide();

    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    const itemsToShow = vendorElements.slice(startIndex, endIndex);

    itemsToShow.forEach(function ($el) {
        $el.show();
    });

    if (vendorElements.length === 0) {
        if ($('#noResultsMessage').length === 0) {
            $('#vendorsGrid').after(`
                <div id="noResultsMessage" class="text-center py-5">
                    <i class="fa-solid fa-inbox fa-3x text-muted mb-3"></i>
                    <h5 class="text-muted">No vendors found</h5>
                    <p class="text-muted small">Try adjusting your search or filter criteria</p>
                </div>
            `);
        }
    } else {
        $('#noResultsMessage').remove();
    }
}

function renderPagination() {
    const totalPages = Math.ceil(vendorElements.length / itemsPerPage);
    const $pagination = $('#vendorsPagination');
    $pagination.empty();

    if (totalPages <= 1) {
        return;
    }

    const maxVisiblePages = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisiblePages / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);

    if (endPage - startPage < maxVisiblePages - 1) {
        startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }

    if (currentPage > 1) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${currentPage - 1}">
                    <i class="fa-solid fa-chevron-left"></i>
                </a>
            </li>
        `);
    }

    if (startPage > 1) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="1">1</a>
            </li>
        `);
        if (startPage > 2) {
            $pagination.append(`
                <li class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
            `);
        }
    }

    for (let i = startPage; i <= endPage; i++) {
        const isActive = i === currentPage;
        $pagination.append(`
            <li class="page-item ${isActive ? 'active' : ''}">
                <a class="page-link" href="#" data-page="${i}">${i}</a>
            </li>
        `);
    }

    if (endPage < totalPages) {
        if (endPage < totalPages - 1) {
            $pagination.append(`
                <li class="page-item disabled">
                    <span class="page-link">...</span>
                </li>
            `);
        }
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${totalPages}">${totalPages}</a>
            </li>
        `);
    }

    if (currentPage < totalPages) {
        $pagination.append(`
            <li class="page-item">
                <a class="page-link" href="#" data-page="${currentPage + 1}">
                    <i class="fa-solid fa-chevron-right"></i>
                </a>
            </li>
        `);
    }
}

function updateResultsCount() {
    const total = vendorElements.length;
    const start = total === 0 ? 0 : (currentPage - 1) * itemsPerPage + 1;
    const end = Math.min(currentPage * itemsPerPage, total);

    let text = '';
    if (total === 0) {
        text = 'No vendors found';
    } else if (total === 1) {
        text = 'Showing 1 vendor';
    } else {
        text = `Showing ${start}-${end} of ${total} vendors`;
    }

    $('#resultsCount').text(text);
}